import { CONTENT_GROUP_TYPE, CONTENT_GROUP_TYPES_WITH_EDITING } from '../constants/cycleDetail';
import {
    checkIsRequiredFieldFilled,
    getValidatedSettingsFormData,
    getValidatedSettingsFormDataIgnoringRequired,
} from './settingsFormUtils';

// check if all fields are valid and all required fields are filled
export const checkIfReadyToSubmit = ({ detailsKeyData, formData }) => {
    let isValid = true;
    const updatedFormData = { ...formData };
    const errorGroupsOrder = [];

    detailsKeyData.forEach((group) => {
        const { order, type } = group;

        if (!CONTENT_GROUP_TYPES_WITH_EDITING.includes(type)) return;

        const groupFormData = formData?.[order] || [];

        let isGroupValid = true;
        let updatedGroupFormData = [];

        if (type === CONTENT_GROUP_TYPE.form) {
            const { areErrorFields, updatedFormData } = getValidatedSettingsFormData({
                settingsFormData: groupFormData,
            });

            if (areErrorFields) {
                isGroupValid = false;
                updatedGroupFormData = updatedFormData;
            }
        }

        if (type === CONTENT_GROUP_TYPE.requirements) {
            const updatedRequirementsFormData = groupFormData.map((requirement) => {
                const { content } = requirement;

                if (!content?.length) return requirement;

                const isEmptyRequiredAnswer = content.some(
                    ({ info_required, answer }) => info_required && !answer
                );

                const missedIncludedItem = content.every(({ is_included }) => !is_included);

                const isSubmissionError = isEmptyRequiredAnswer || missedIncludedItem;

                if (isSubmissionError) {
                    isGroupValid = false;
                    return { ...requirement, state: 'error' };
                }

                return requirement;
            });

            updatedGroupFormData = updatedRequirementsFormData;
        }

        if (type === CONTENT_GROUP_TYPE.variables) {
            const updatedVariablesFormData = groupFormData.map((variable) => {
                const { example } = variable;
                const isError = variable.hasOwnProperty('example') && !example;

                if (isError) {
                    isGroupValid = false;
                    return { ...variable, state: 'error' };
                }

                return variable;
            });

            updatedGroupFormData = updatedVariablesFormData;
        }

        if (type === CONTENT_GROUP_TYPE.steps) {
            const updatedStepsFormData = groupFormData.map((step) => {
                const { settings, context } = step;
                const merged = [...(settings || []), ...(context || [])];

                const hasMissingRequiredField = merged.some(
                    (item) => !checkIsRequiredFieldFilled(item)
                );

                if (hasMissingRequiredField) {
                    isGroupValid = false;
                    return { ...step, state: 'error' };
                }

                return step;
            });

            updatedGroupFormData = updatedStepsFormData;
        }

        if (!isGroupValid) {
            isValid = false;
            errorGroupsOrder.push(order);
            updatedFormData[order] = updatedGroupFormData;
        }

        return isGroupValid;
    });

    return { isValid, updatedFormData, errorGroupsOrder };
};

export const checkIfReadyToSaveChanges = ({ detailsKeyData, formData }) => {
    let isValid = true;
    const updatedFormData = { ...formData };
    const errorGroupsOrder = [];

    detailsKeyData.forEach((group) => {
        const { order, type } = group;

        let isGroupValid = true;
        let updatedGroupFormData = [];

        if (type === CONTENT_GROUP_TYPE.form) {
            const groupFormData = formData?.[order] || [];

            const { areErrorFields, updatedFormData } =
                getValidatedSettingsFormDataIgnoringRequired({
                    settingsFormData: groupFormData,
                });

            if (areErrorFields) {
                isGroupValid = false;
                updatedGroupFormData = updatedFormData;
            }
        }

        if (!isGroupValid) {
            isValid = false;
            errorGroupsOrder.push(order);
            updatedFormData[order] = updatedGroupFormData;
        }
    });

    return { isValid, updatedFormData, errorGroupsOrder };
};
